module.exports = __webpack_public_path__ + "static/media/JasonSummers_2026.8f270601.jpg";